import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Divider Component
 * Reusable divider/separator component (e.g., "Or" divider)
 */
@Component({
  selector: 'app-divider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './divider.html',
  styleUrl: './divider.scss',
})
export class Divider {
  @Input() text: string = '';
  @Input() containerClass: string = 'flex items-center my-4';
  @Input() lineClass: string = 'divider-line';
  @Input() textClass: string = 'mx-2 text-gray-500 text-sm';
}
